<template>
  <div class="app">
    <div style="width:100vw;height:7.71vh;display:flex;flex-wrap:wrap;align-items:center;">
      <img src="@/assets/logo.png" style="width:12.56vw;height:12.56vw;margin-left:5.13vw;margin-right:2.56vw" />
      <div style="width:60vw;display:flex;flex-wrap:wrap">
        <div style="font-size:5vw;font-weight:bold;">Loop</div>
        <div style="font-size:3vw;width:64vw;">Professional platform for skipping rope training</div>
      </div>
      <div style="width:14vw;display:flex;flex-wrap:wrap;justify-content:center;" @click="pullAppEn()">
        <img src="@/assets/download.png" style="width:7vw;height:7vw" />
        <div style="font-size:2vw">Download</div>
      </div>
    </div>
    <div style="width:100vw;height:92.29vh;display:flex;flex-wrap:wrap;align-items:start;justify-content:center;background-image: linear-gradient(#103fd8, #00b1ff);color:#103fd8;position:relative">
      <img src="@/assets/groupBackground.png" style="margin-top:6.94vh;width:96vw;height:20.83vh"/>
      <div style="width:88vw;height:47.69vh;box-shadow: 0px 3px 5px rgba(103, 1, 198, 0.47);border-radius:9vw;background:#FFFFFF;position:absolute;top:25.92vh;display:flex;flex-wrap:wrap;justify-content:center;align-content:start;">
        <img :src="parm5" style="margin-top:2.31vh;width:16vw;height:16vw;border-radius:50%" v-if="parm5">
        <div style="margin-top:2.31vh;width:16vw;height:16vw;border-radius:50%" v-else></div>
        <div style="font-size:2vw;color:black;width:100%;display:flex;justify-content:center;">{{ parm4 }}</div>
        <div style="width:73vw;height:1px;border-bottom:1px dashed #08A4FE"></div>
        <div style="width:88vw;height:11.11vh;display:flex;flex-wrap:wrap;margin-left:12vw;align-items:center;">
          <img :src="require(`@/assets/groupIcon${group.type}.jpg`)" style="width:12vw;height:12vw;margin-right:2vw;"/>
          <div>
              <div style="font-size:4vw;color:black;">{{group.name}}</div>
              <div style="font-size:3vw;color:black">Members: {{group.count}}</div>
          </div>
        </div>
        <div style="width;58vw">
            <div style="width:100%;font-size:6vw;color:#0B9FFD;margin-bottom:4px;">Join the group</div>
            <div style="width:100%;font-size:6vw;color:#0B9FFD;margin-bottom:5px;">Train with me！</div>
        </div>
        <div v-if="group.inviteCode" style="width:100%;text-align:center;font-size:4vw;color:#6A6A6A;margin-bottom:1.38vh;margin-top:1.85vh;">Invitation Code</div>
        <div v-if="group.inviteCode" style="width:100%;text-align:center;font-size:4vw;color:#6A6A6A;margin-bottom:1.38vh;">(Long press the button below to copy)</div>
        <div v-if="group.inviteCode" style="width:36vw;height:5vh;border-radius:5vw;background: linear-gradient(181deg, #00B1FF 0%, #00B1FF 0%, #335DF7 100%);color:white;font-size:5vw;display:flex;justify-content:center;align-items:center;">{{group.inviteCode}}</div>
      </div>
      <div @click="openLoopApp()" style="width:72vw;height:6vh;background:#FFD500;box-shadow:0px 1px 2px rgba(0, 0, 0, .16);border-radius:5vw;color:white;font-size:5vw;position:absolute;top:81.94vh;display:flex;justify-content:center;align-items:center;">Go to Loop to see more</div>
    </div>
  </div>
</template>

<script>
  export default {
    data: function() {
      return {
        parm1: 0,
        parm2: 0,
        parm3: 0,
        parm4: '',
        parm5: '1D3E',
        group: {
          name: 'Loop group',
          type: 1,
          count: 200,
          inviteCode: '',
        },
      };
    },
    mounted() {
      let query = this.$route.query;
      this.parm1 = query.parm1,
      this.parm2 = query.parm2,
      this.parm3 = query.parm3,
      this.parm4 = query.parm4,
      this.parm5 = query.parm5,
      this.getData();
    },
  
    methods: {

      async getData() {
        let res = await this.axios.post('https://api.loopsports.cn/user/getGroupForShare', {
          id: this.parm1 - 0,
          ut: this.parm2 - 0,
          sign: this.parm3
        });
        let data = res.data.Data;
        if (data == null) {
          return;
        }
      
        this.group = data;
        console.log(this.group);
      },
      openLoopApp() {
        var device = navigator.userAgent;
        window.location.href = `loopischeme://joingroup?id=${this.parm1}`
        if (device.indexOf('Android') > -1) {
          setTimeout(() => {
            window.location.href = 'https://play.google.com/store/apps/details?id=com.justjump.loopintl'; 
          }, 3000)
        } else if (device.indexOf('iPhone') > -1) {
          window.setTimeout(() => {
            window.location.href = 'https://apps.apple.com/cn/app/id1617032569'; 
          }, 2000)
        }
      },
    },
  };
</script>

<style>

</style>
